import React, { useState, useEffect } from 'react';
import axios from "axios";
import { DataGrid } from '@mui/x-data-grid';
import {
  Button,
  Popover,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Grid,
  Typography,
  Divider,
  Tooltip
} from '@mui/material';
import { Visibility, Close } from '@mui/icons-material';
import { useOutletContext } from 'react-router-dom';
import api from "../config/backend";
import './css/LeadsView.css';
import { FileDownload } from '@mui/icons-material';
import DownloadExportData from '../utils/excel';

// Your existing renderTags function here

export function renderTags(params) {
  const tags = params.row.tags;

  if (!tags || tags.length === 0) {
    return null;
  }

  const firstTag = tags[0].name;
  const remainingTags = tags.slice(1);

  const handlePopoverOpen = (event) => {
    params.setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    params.setAnchorEl(null);
  };

  return (
    <div>
      <span>{firstTag}</span>
      {remainingTags.length > 0 && (
        <Button variant="text" size="small" onClick={handlePopoverOpen}>
          +1
        </Button>
      )}
      <Popover
        open={Boolean(params.anchorEl)}
        anchorEl={params.anchorEl}
        onClose={handlePopoverClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <div style={{ padding: '8px' }}>
          {remainingTags.map((tag, index) => (
            <div key={index}>{tag.name}</div>
          ))}
        </div>
      </Popover>
    </div>
  );
}


function LeadsView() {
  // const searchLead = useOutletContext()[2];
  const [triggerRefresh, setTriggerRefresh, searchLead, filters, rows] = useOutletContext();
  // const [rows, setRows] = useState([]);// eslint-disable-line no-unused-vars
  const [selectedLead, setSelectedLead] = useState(null);
  const [showViewModal, setShowViewModal] = useState(false);
  const token = localStorage.getItem("_crm__token");

  const columns = [
    { field: 'id', headerName: 'S No', width: 100, headerAlign: 'left', align: 'left' },
    { field: 'company', headerName: 'Company', width: 130, headerAlign: 'center', align: 'center' },
    {
      field: 'createdby', headerName: 'Created By', width: 150, headerAlign: 'center', align: 'center', valueGetter: (params) => {
        return params.row.EmployeeId?.firstName + params.row.EmployeeId?.lastName || params.row.EmployeeId?.username || 'N/A';
      }
    },
    { field: 'createdAt', headerName: 'Created date', width: 130, headerAlign: 'center', align: 'center' },
    { field: 'clientname', headerName: 'Name', width: 130, sticky: 'left', headerAlign: 'center', align: 'center' },
    // { field: 'clientemail', headerName: 'Email', width: 130, sticky: 'left', headerAlign: 'center', align: 'center' },
    { field: 'clientphone', headerName: 'Phone', width: 130, sticky: 'left', headerAlign: 'center', align: 'center' },
    { field: 'dealsize', headerName: 'Deal size', width: 130, headerAlign: 'center', align: 'center' },
    // { field: 'description', headerName: 'Description', width: 180, headerAlign: 'center', align: 'center' },
    { field: 'website', headerName: 'Website', width: 180, headerAlign: 'center', align: 'center' },
    {
      field: 'actions',
      headerName: 'Actions',
      width: 100,
      headerAlign: 'center',
      align: 'center',
      sortable: false,
      renderCell: (params) => (
        <Tooltip title="View Details">
          <IconButton
            onClick={() => handleViewLead(params.row._id)}
            size="small"
            className="view-btn"
          >
            <Visibility fontSize="small" />
          </IconButton>
        </Tooltip>
      ),
    },
  ];

  const fetchLeads = async () => {
    const { data, status } = await axios.post(`${api}/Leads/getleads`, {
      token,
      view: "list",
      employeeId: filters?.employeeId || undefined,
      startDate: filters?.startDate || undefined,
      endDate: filters?.endDate || undefined
    });

    if (data.success) {
      const formattedRows = data.leads.map((item, index) => {
        const copy = { ...item };
        copy.id = index;
        if (Array.isArray(copy.tags) && copy.tags.length > 0) {
          copy.tags = copy.tags.map(tag => tag.name).join(', ');
        } else {
          copy.tags = '';
        }

        return copy;
      });

      // setRows(formattedRows);
    }
  };
  console.log("filters", filters);
  console.log("rows", rows);

  useEffect(() => {
    fetchLeads();
  }, [triggerRefresh]);

  const handleViewLead = async (id) => {
    try {
      // Assuming you have an API endpoint to get lead details by ID
      const response = await axios.post(`${api}/Leads/get-lead-by-id`, {
        token,
        leadId: id
      });
      console.log("response", response);

      if (response.data.success) {
        setSelectedLead(response.data.Leaddata);
        setShowViewModal(true);
      }
    } catch (error) {
      console.error('Error fetching lead details:', error);
    }
  };
  console.log("rows",rows);
  
  return (
    <>
      <div className="app-table">

        <DataGrid
          rows={rows.filter(item => (item.clientemail && item.clientemail.toLowerCase().includes(searchLead.toLowerCase())) || (item.clientname && item.clientname.toLowerCase().includes(searchLead.toLowerCase())))}
          columns={columns}
          initialState={{
            pagination: {
              paginationModel: { page: 0, pageSize: 10 },
            },
          }}
          pageSizeOptions={[5, 10]}
        />

        {/* Lead Details Modal */}
        {showViewModal && selectedLead && (
          <Dialog
            open={showViewModal}
            onClose={() => setShowViewModal(false)}
            maxWidth="md"
            fullWidth
            className="lead-modal"
          >
            <DialogTitle className="modal-title">
              Lead Details
              <IconButton onClick={() => setShowViewModal(false)} className="close-button">
                <Close />
              </IconButton>
            </DialogTitle>

            <DialogContent dividers className="lead-details-content">
              <Grid container spacing={2}>
                {/* Lead Header */}
                <Grid item xs={12} className="lead-header-section">
                  <Typography variant="h5">
                    {selectedLead.company}
                  </Typography>
                  <Typography variant="subtitle1" color="textSecondary">
                    {selectedLead.clientname} - {selectedLead.designation || 'No Designation'}
                  </Typography>
                </Grid>

                <Grid item xs={12}>
                  <Divider />
                </Grid>

                {/* Contact Information */}
                <Grid item xs={12}>
                  <Typography variant="h6" className="section-title">
                    Contact Information
                  </Typography>
                </Grid>

                <Grid item xs={12} sm={6} md={4} className="grid-item-label-value">
                  <Typography variant="subtitle2" className="grid-item-label">
                    Email
                  </Typography>
                  <Typography variant="body1" className="grid-item-value">
                    {selectedLead.clientemail || <span className="not-specified">Not specified</span>}
                  </Typography>
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <Typography variant="subtitle2" color="textSecondary">
                    Phone
                  </Typography>
                  <Typography variant="body1">
                    {selectedLead.clientphone || 'Not specified'}
                  </Typography>
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <Typography variant="subtitle2" color="textSecondary">
                    Website
                  </Typography>
                  <Typography variant="body1">
                    {selectedLead.website || 'Not specified'}
                  </Typography>
                </Grid>

                {/* Address Information */}
                <Grid item xs={12}>
                  <Typography variant="h6" className="section-title">
                    Address Information
                  </Typography>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Typography variant="subtitle2" color="textSecondary">
                    Address
                  </Typography>
                  <Typography variant="body1">
                    {selectedLead.google_address
                      ? selectedLead.google_address
                      : (selectedLead.address || '') +
                      (selectedLead.city ? ', ' + selectedLead.city : '') +
                      (selectedLead.state ? ', ' + selectedLead.state : '') +
                      (selectedLead.country ? ', ' + selectedLead.country : '') +
                      (selectedLead.zip ? ' - ' + selectedLead.zip : '') || 'Not specified'}
                  </Typography>
                </Grid>

                {/* <Grid item xs={12} sm={6} md={3}>
                  <Typography variant="subtitle2" color="textSecondary">
                    City
                  </Typography>
                  <Typography variant="body1">
                    {selectedLead.city || 'Not specified'}
                  </Typography>
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                  <Typography variant="subtitle2" color="textSecondary">
                    State
                  </Typography>
                  <Typography variant="body1">
                    {selectedLead.state || 'Not specified'}
                  </Typography>
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                  <Typography variant="subtitle2" color="textSecondary">
                    Country
                  </Typography>
                  <Typography variant="body1">
                    {selectedLead.country || 'Not specified'}
                  </Typography>
                </Grid> */}

                <Grid item xs={12} sm={6} md={3}>
                  <Typography variant="subtitle2" color="textSecondary">
                    Zip Code
                  </Typography>
                  <Typography variant="body1">
                    {selectedLead.zipcode || 'Not specified'}
                  </Typography>
                </Grid>

                {/* Deal Information */}
                <Grid item xs={12}>
                  <Typography variant="h6" className="section-title">
                    Deal Information
                  </Typography>
                </Grid>

                <Grid item xs={12} sm={6} md={8}>
                  <Typography variant="subtitle2" color="textSecondary">
                    Discription
                  </Typography>
                  <Typography variant="body1">
                    {selectedLead.description || 'Not specified'}
                  </Typography>
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <Typography variant="subtitle2" color="textSecondary">
                    Deal Size
                  </Typography>
                  <Typography variant="body1">
                    {selectedLead.dealsize || 'Not specified'}
                  </Typography>
                </Grid>

                {/* <Grid item xs={12} sm={6} md={4}>
                  <Typography variant="subtitle2" color="textSecondary">
                    Privacy
                  </Typography>
                  <Typography variant="body1">
                    {selectedLead.privacy || 'Not specified'}
                  </Typography>
                </Grid> */}

                {/* Created By Information */}
                <Grid item xs={12}>
                  <Typography variant="h6" className="section-title">
                    System Information
                  </Typography>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Typography variant="subtitle2" color="textSecondary">
                    Created By
                  </Typography>
                  <Typography variant="body1">
                    {selectedLead?.EmployeeId?.firstName + selectedLead?.EmployeeId?.lastName || selectedLead?.EmployeeId?.username || 'Not specified'}
                  </Typography>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Typography variant="subtitle2" color="textSecondary">
                    Created At
                  </Typography>
                  <Typography variant="body1">
                    {new Date(selectedLead.createdAt).toLocaleString()}
                  </Typography>
                </Grid>

                {/* Description if available */}
                {selectedLead.document && (
                  <>
                    <Grid item xs={12}>
                      <Typography variant="h6" className="section-title">
                        Document
                      </Typography>
                    </Grid>

                    <Grid item xs={12}>
                      <Typography variant="body1">
                        <img src={`${api}/public/${selectedLead.document}`} alt='document' width={'200px'} />
                      </Typography>
                    </Grid>
                  </>
                )}
              </Grid>
            </DialogContent>

            <DialogActions className="modal-actions">
              <Button onClick={() => setShowViewModal(false)} color="primary">
                Close
              </Button>
            </DialogActions>
          </Dialog>
        )}
      </div>
    </>
  );
}

export default LeadsView;
